import { defineMessages, useIntl } from 'react-intl';
import classNames from 'classnames';
import styles from './AmountSummary.module.scss';

const messages = defineMessages({
	orderAmount: {
		id: 'payments.order_amount',
		defaultMessage: 'Order amount',
	},
	networkFee: {
		id: 'payments.network_fee',
		defaultMessage: 'Network fee',
	},
	totalAmount: {
		id: 'payments.total_pay_amount',
		defaultMessage: 'Total amount',
	},
});

const InfoRow = ({
	isTotalAmount,
	label,
	value,
}: {
	isTotalAmount?: boolean;
	label: string;
	value: string;
}) => {
	return (
		<div className={classNames(styles.field, { [styles.totalAmount]: isTotalAmount })}>
			<span>{label}</span>
			<span className={styles.value}>{value}</span>
		</div>
	);
};

interface AmountSummaryProps {
	currencyCode: string;
	orderAmount: string;
	networkFee: string;
	totalAmount: string;
}

const AmountSummary = ({
	currencyCode,
	orderAmount,
	networkFee,
	totalAmount,
}: AmountSummaryProps) => {
	const { formatMessage } = useIntl();

	return (
		<div className={styles.container}>
			{!!orderAmount && (
				<InfoRow
					label={formatMessage(messages.orderAmount)}
					value={`${orderAmount} ${currencyCode}`}
				/>
			)}
			{!!networkFee && (
				<InfoRow
					label={formatMessage(messages.networkFee)}
					value={`+ ${networkFee} ${currencyCode}`}
				/>
			)}
			{!!totalAmount && (
				<InfoRow
					isTotalAmount
					label={formatMessage(messages.totalAmount)}
					value={`${totalAmount} ${currencyCode}`}
				/>
			)}
		</div>
	);
};

export default AmountSummary;
